/* eslint-disable */
import { initializeApp } from "firebase/app";
import {
  getAuth, setPersistence, browserLocalPersistence, RecaptchaVerifier,
  signInWithPhoneNumber, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail, EmailAuthProvider, linkWithCredential, updatePassword, sendPasswordResetEmail, sendEmailVerification,
} from "firebase/auth";
import { getFirestore, collection, addDoc, setDoc, serverTimestamp, onSnapshot, query, where, doc, updateDoc, getDoc, getDocs, orderBy, limit, Timestamp, deleteDoc, deleteField, increment, writeBatch, runTransaction } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDIrTeJhWUgnb6kEsQae2TcKGmcd93VpTE",
  authDomain: "go-ca-ac02b.firebaseapp.com",
  databaseURL: "https://go-ca-ac02b-default-rtdb.firebaseio.com",
  projectId: "go-ca-ac02b",
  storageBucket: "go-ca-ac02b.firebasestorage.app",
  messagingSenderId: "952766051421",
  appId: "1:952766051421:web:93a7a9eae95adb4cd589b4"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
setPersistence(auth, browserLocalPersistence);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp, "us-central1");

// ── FCM (Push Notifications) ──────────────────────────────────────────
let messaging = null;
let messagingInitPromise = null;

const ensureMessaging = async () => {
  if (messaging) return messaging;
  if (typeof window === "undefined" || typeof navigator === "undefined") return null;
  if (messagingInitPromise) return messagingInitPromise;

  messagingInitPromise = (async () => {
    try {
      const { getMessaging, isSupported } = require("firebase/messaging");
      const supported = typeof isSupported === "function"
        ? await isSupported().catch(() => false)
        : true;
      if (!supported) {
        console.log("FCM not supported");
        return null;
      }
      messaging = getMessaging(firebaseApp);
      return messaging;
    } catch (e) {
      console.log("FCM not supported");
      return null;
    }
  })();

  return messagingInitPromise;
};

// ── Google Maps ───────────────────────────────────────────────────────
const GMAPS_KEY = "AIzaSyCPCNKOwA45P13kcOHn7kKfmg2YhI_GYwI";
const GTA_BOUNDS = { sw: { lat: 43.3, lng: -80.0 }, ne: { lat: 44.3, lng: -78.6 } };

let _gmapsPromise = null;
const loadGoogleMaps = () => {
  if (_gmapsPromise) return _gmapsPromise;
  _gmapsPromise = new Promise(resolve => {
    if (window.google && window.google.maps) { resolve(); return; }
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_KEY}&libraries=places`;
    s.async = true;
    s.onload = resolve;
    document.head.appendChild(s);
  });
  return _gmapsPromise;
};

// ── ADMIN EMAILS (改成你自己嘅 email) ─────────────────────────────────
const ADMIN_EMAILS = ["2449969@gmail.com"];
const ADMIN_UIDS = ["0RihqdBDuvd0ZqqWQ2la8yjIEFK2"];

// ── FCM VAPID KEY (從 Firebase Console > Cloud Messaging 攞) ──────────
const VAPID_KEY = "BP8BkUD2USqFylM7Z-le1YeJO8MYYROWE54yO1F2NPL8DbguvGE_oR8faz7ifrkbEf2oHDkMDHCLyd16oBLqsHY";

const requestNotificationPermission = async (uid, role) => {
  const localMessaging = await ensureMessaging();
  if (!localMessaging) return null;
  try {
    const { getToken } = require("firebase/messaging");
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(localMessaging, { vapidKey: VAPID_KEY });
      const col = role === "driver" ? "drivers" : "passengers";
      await updateDoc(doc(db, col, uid), { fcmToken: token });
      await initForegroundNotifications();
      return token;
    }
  } catch(e) {
    console.log("Notification permission error:", e);
  }
  return null;
};

/** App 開住時 FCM 唔會自動彈系統通知，用瀏覽器 Notification 補上 */
let foregroundNotificationsReady = false;
const initForegroundNotifications = async () => {
  const localMessaging = await ensureMessaging();
  if (!localMessaging || foregroundNotificationsReady) return;
  try {
    const { onMessage } = require("firebase/messaging");
    onMessage(localMessaging, (payload) => {
      const title = payload.notification?.title || "八達Go";
      const body = payload.notification?.body || "";
      if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
      try {
        const tag = payload.data?.orderId ? `8go-${payload.data.orderId}` : "8go-general";
        new Notification(title, { body, icon: "/favicon.ico", tag, data: payload.data });
      } catch (e) {
        /* ignore */
      }
    });
    foregroundNotificationsReady = true;
  } catch (e) {
    console.log("initForegroundNotifications:", e);
  }
};

// ── HELPER: Upload file to Storage ────────────────────────────────────
const uploadFile = async (file, path) => {
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

// ── HELPER: Calculate real distance/ETA ───────────────────────────────
const calcDistanceETA = (origin, dest) => {
  return new Promise((resolve) => {
    loadGoogleMaps().then(() => {
      const svc = new window.google.maps.DistanceMatrixService();
      svc.getDistanceMatrix({
        origins: [origin],
        destinations: [dest],
        travelMode: "DRIVING",
        unitSystem: window.google.maps.UnitSystem.METRIC,
      }, (res, status) => {
        if (status === "OK") {
          const el = res.rows[0].elements[0];
          if (el.status === "OK") {
            resolve({
              distKm: (el.distance.value / 1000).toFixed(1),
              distText: el.distance.text,
              durMin: Math.round(el.duration.value / 60),
              durText: el.duration.text,
            });
            return;
          }
        }
        resolve(null);
      });
    });
  });
};

// ── HELPER: Generate referral code from UID ───────────────────────────
const genReferralCode = (uid) => {
  return "8GO" + uid.substring(0, 6).toUpperCase();
};

/** 預約時間尚在未來 → 用 scheduled_pending；否則即時行程用 grabbed */
export const getMatchStatusAfterConfirm = (orderData) => {
  if (!orderData?.isScheduled || !orderData?.scheduledTime) return "grabbed";
  try {
    const t = orderData.scheduledTime.toDate
      ? orderData.scheduledTime.toDate().getTime()
      : new Date(orderData.scheduledTime).getTime();
    if (t > Date.now()) return "scheduled_pending";
  } catch (e) {
    /* ignore */
  }
  return "grabbed";
};

/** 已到／過咗預約時間則升級做正式進行中 */
export const shouldPromoteScheduledPending = (orderData) => {
  if (orderData?.status !== "scheduled_pending" || !orderData?.scheduledTime) return false;
  try {
    const t = orderData.scheduledTime.toDate
      ? orderData.scheduledTime.toDate().getTime()
      : new Date(orderData.scheduledTime).getTime();
    return Date.now() >= t;
  } catch (e) {
    return false;
  }
};

/** 回復「開放配對」時清除車主欄位（雙向確認未完成時用） */
export const ORDER_CLEAR_DRIVER = {
  driverId: null,
  driverName: null,
  driverPlate: null,
  driverPhone: null,
  driverLang: null,
  driverVtype: null,
  driverLocation: null,
  driverAvgRating: null,
  driverOccupation: null,
  driverExpertise: null,
  driverHobbies: null,
  grabbedAt: null,
  driverAcceptedAt: null,
  passengerInvitedAt: null,
};

export {
  firebaseApp, auth, db, storage, messaging, functions,
  GMAPS_KEY, GTA_BOUNDS, ADMIN_EMAILS, ADMIN_UIDS, VAPID_KEY,
  loadGoogleMaps, requestNotificationPermission, initForegroundNotifications, uploadFile, calcDistanceETA, genReferralCode,
  // Re-exports
  collection, addDoc, setDoc, serverTimestamp, onSnapshot, query, where, doc, updateDoc, getDoc, getDocs, orderBy, limit, Timestamp, deleteDoc, deleteField, increment, writeBatch, runTransaction,
  httpsCallable,
  RecaptchaVerifier, signInWithPhoneNumber, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail, EmailAuthProvider, linkWithCredential, updatePassword, sendPasswordResetEmail, sendEmailVerification,
  ref, uploadBytes, getDownloadURL,
};
